import React from "react";
import {
    ArrowLeftRight,
    Database,
    Globe,
    Loader2,
    Package,
    Upload,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { DosyaMuvekkilSelect, RayicAccordion } from "./RayicShared";

const PARCA_ALT_TABS = [
    { id: "dosya", label: "Dosyadan", icon: Database },
    { id: "ekspertiz", label: "Ekspertiz", icon: Upload },
    { id: "karsilastir", label: "Karşılaştır", icon: ArrowLeftRight },
];

export default function RayicParcaSidebar({
    parcaAltTab,
    setParcaAltTab,
    parcaDosyaId,
    setParcaDosyaId,
    setForm,
    parcaBusy,
    parcaUploadBusy,
    parcaDerin,
    setParcaDerin,
    onDosyaYukle,
    onParcaArastir,
    onEkspertizYukle,
    onDerinTab,
    onRaporTab,
}) {
    return (
        <div className="space-y-2 h-full overflow-y-auto">
            <RayicAccordion title="Parça modu" defaultOpen>
                <div className="flex flex-wrap gap-1">
                    {PARCA_ALT_TABS.map((st) => {
                        const Icon = st.icon;
                        const active = parcaAltTab === st.id;
                        return (
                            <button
                                key={st.id}
                                type="button"
                                onClick={() => setParcaAltTab(st.id)}
                                className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-[10px] border transition ${
                                    active
                                        ? "bg-orange-500/15 text-orange-300 border-orange-500/30"
                                        : "border-white/10 text-slate-400 hover:text-white"
                                }`}
                            >
                                <Icon className="h-3 w-3" />
                                {st.label}
                            </button>
                        );
                    })}
                </div>
                {parcaAltTab === "ekspertiz" ? (
                    <p className="text-[10px] text-slate-500 mt-2">
                        PDF/fotoğraf yükleyin — satırlar otomatik okunur.
                    </p>
                ) : null}
            </RayicAccordion>

            <RayicAccordion title="Dosya & araştır" defaultOpen>
                <div className="space-y-2">
                    <DosyaMuvekkilSelect
                        value={parcaDosyaId}
                        onChange={setParcaDosyaId}
                        onDosyaMeta={(row) => {
                            setParcaDosyaId(String(row.id));
                            setForm((f) => ({
                                ...f,
                                marka: row.marka || f.marka,
                                model: row.model || f.model,
                                model_yili: row.model_yili || f.model_yili,
                                dosya_id: String(row.id),
                            }));
                        }}
                    />
                    <Button
                        variant="outline"
                        size="sm"
                        className="w-full h-8 text-xs border-white/10"
                        onClick={onDosyaYukle}
                        disabled={parcaBusy}
                    >
                        {parcaBusy ? (
                            <Loader2 className="h-3.5 w-3.5 animate-spin mr-1" />
                        ) : (
                            <Database className="h-3.5 w-3.5 mr-1" />
                        )}
                        Dosyayı Getir
                    </Button>
                    <Button
                        size="sm"
                        className="w-full h-8 text-xs bg-orange-500 text-black hover:bg-orange-400"
                        onClick={onParcaArastir}
                        disabled={parcaBusy || parcaUploadBusy}
                    >
                        <Package className="h-3.5 w-3.5 mr-1" />
                        Parça Araştır
                    </Button>
                    <label className="block">
                        <input
                            type="file"
                            accept=".pdf,.jpg,.jpeg,.png,.webp"
                            className="hidden"
                            onChange={onEkspertizYukle}
                            disabled={parcaUploadBusy}
                        />
                        <span className="flex items-center justify-center gap-1.5 w-full h-8 px-2 rounded-md border border-dashed border-orange-500/40 text-[10px] text-orange-300 cursor-pointer hover:bg-orange-500/10">
                            {parcaUploadBusy ? (
                                <Loader2 className="h-3.5 w-3.5 animate-spin" />
                            ) : (
                                <Upload className="h-3.5 w-3.5" />
                            )}
                            Ekspertiz Yükle
                        </span>
                    </label>
                    <label className="flex items-center gap-1.5 text-[10px] text-slate-400 cursor-pointer">
                        <input
                            type="checkbox"
                            checked={parcaDerin}
                            onChange={(e) => setParcaDerin(e.target.checked)}
                            className="rounded border-white/20"
                        />
                        <Globe className="h-3 w-3 text-cyan-400" />
                        OEM + site taraması (derin, yavaş)
                    </label>
                </div>
            </RayicAccordion>

            <RayicAccordion title="Hızlı geçiş" defaultOpen={false}>
                <div className="flex flex-col gap-1.5">
                    <button
                        type="button"
                        onClick={onDerinTab}
                        className="text-left text-[10px] px-2 py-1.5 rounded-md border border-cyan-500/30 text-cyan-300 hover:bg-cyan-500/10"
                    >
                        Derin tarama sekmesi
                    </button>
                    <button
                        type="button"
                        onClick={onRaporTab}
                        className="text-left text-[10px] px-2 py-1.5 rounded-md border border-amber-500/30 text-amber-300 hover:bg-amber-500/10"
                    >
                        Rapor önizleme
                    </button>
                </div>
            </RayicAccordion>
        </div>
    );
}
